// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"l0-z"};